import { useQuery } from "@tanstack/react-query";
import { wrapperResult } from "@api/osp";
import { useEffect, useMemo, useRef, useState } from "react";
import { CRYPTO_THEME_LABELS, radarCryptoDomain } from "../componentsv1";
import { OpenDataTokenResult, DashboardRequestParam } from "./types";
import { useOspApiClientProvider } from "@hooks";
import { QUERY_KEYS } from "@config";

const PAGE_SIZE = 10;
// 1、返回单位  K  M B
// 2、5m 1h 6h 24h 都在pool里面？
// 3、pool 已经有 5m 1h 6h 24h 数据  sortBy 接口参数有什么用处
// 4、产品文档上 左侧A b C 过滤机制是服务端做了吧
// 5、

// [
//   "Token",
//   "Age",   // tokenCreatedAt
//   "MC/ Vol",   //   / vol24h
//   "Turnover Rate",  // priceChange***
//   "5m Smart Buy",  //  smartBuyVol***
//   "5m Smart Sell", // smartSellVol***
//   "Price",     // price
//   "5m Change",  // priceChange***
//   "1h Vol𝚫Δ",     // volChange1h volChange1h
//   "Engaged Influencers",
//   "24H Volume",   // vol24h
//   "Market cap"    // marketCap
// ]
export const useTokenSeekDashboard = (params: DashboardRequestParam) => {
  const {
    enabled = true,
    source = "radar",
    gcTime = 0,
    staleTime = 30 * 1000,
  } = params;

  const { openApi } = useOspApiClientProvider();
  const [currentPage, setCurrentPage] = useState(1);
  const pageLimit = params?.pageSize || PAGE_SIZE;
  const lastDexIdRef = useRef(params.dex_id);
  const availablePage =
    lastDexIdRef.current !== params.dex_id ? 1 : currentPage;
  useEffect(() => {
    setCurrentPage(1);
    // 解决 切换tab currentPage 翻页后不变
    lastDexIdRef.current = params.dex_id;
  }, [params.dex_id]);
  const dexIdMap = {
    news: "news",
    [CRYPTO_THEME_LABELS.blueChip]: "bluechip",
    [radarCryptoDomain.dexTracker]: "trending",
  } as const;
  const dexId = dexIdMap[params.dex_id as keyof typeof dexIdMap];
  const result = useQuery({
    enabled: !!openApi && !!params.dex_id && enabled,
    /**
     * 30s 后重新请求
     */
    staleTime,
    gcTime,
    queryKey: [
      QUERY_KEYS.TOKEN_DASHBOARD,
      "tokenseek",
      "dashboard",
      params.sort,
      availablePage,
      params.pageSize,
      params.dex_id,
    ],
    queryFn: async () => {
      if (!params.dex_id) {
        return null;
      }
      const data = await wrapperResult(
        openApi!.tokenseek.listOpenDataToken(dexId!, {
          limit: pageLimit,
          page: availablePage - 1, // API 从0开始计数

          // @ts-ignore
          sort:
            params.dex_id === CRYPTO_THEME_LABELS.blueChip && source === "radar"
              ? "market_cap"
              : params.sort === "vol_7d"
                ? "vol_24h"
                : params.sort,
        }),
      );
      return data;
    },
  });

  // 处理翻页
  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };
  const selectData = useMemo(() => {
    return (result.data?.rows || []).map((row: any) => {
      // 接口说直接取第0个
      // cex 的数据直接返回

      const tokenPool =
        params.dex_id === CRYPTO_THEME_LABELS.blueChip ||
        params.dex_id === "news"
          ? row
          : row.pools?.[0];

      // memecoins poolAddress 取pool_address，blue-chiptokens 为空
      const poolAddress = tokenPool?.pool_address || "";
      return {
        ...row,
        poolAddress,
        trade: tokenPool?.trade,
        key: `${row.name}-${row.token_created_at}`,
      } as OpenDataTokenResult;
    });
  }, [result.data?.rows]);

  return {
    ...result,
    pagination: {
      current: availablePage,
      pageSize: pageLimit,
      total: result.data?.total || 0,
      onChange: onPageChange,
    },
    data: {
      data: selectData,
      total: result.data?.total || 0,
    },
  };
};
